import type {
  TransactionGroup,
  UserBalance,
} from "schema/gen/es/chiikipoint/model/v2/model_pb";
import { css } from "../../../../styled-system/css";
import { formatTimestamp } from "../../../libs/date";
import { t } from "../../../libs/i18n";
import { formatNumber } from "../../../libs/utils";
import { Cell } from "./cell";

type GrantTransactionDetailProps = {
  transactionGroup: TransactionGroup;
  balances: UserBalance[];
};

export function GrantTransactionDetail({
  transactionGroup,
  balances,
}: GrantTransactionDetailProps) {
  const summaryDetail = transactionGroup.transactionDetails[0];
  const reason = summaryDetail.transaction?.reason;
  const amount = transactionGroup.transactionDetails.reduce(
    (acc: number, ts) => acc + Number(ts.transaction?.amount || 0),
    0,
  );
  const fundSource = summaryDetail.fundSource?.name || t("不明");
  // grantは必ず1つのbalanceのみ存在する
  const expireAt = balances.length > 0 ? (balances[0].expireAt ?? null) : null;

  return (
    <div
      className={css({
        bg: "white",
        px: "16px",
        rounded: "16px",
      })}
    >
      <Cell label={t("取引種別")} value={t("ポイント獲得")} />
      <Cell label={t("獲得ポイント")} value={`${formatNumber(amount)}pt`} />
      <Cell label={t("ポイント種類")} value={fundSource} />
      {summaryDetail.fundSource?.type === "AdminGrant" && reason && (
        <Cell label={t("発行理由")} value={reason} />
      )}
      {expireAt && (
        <Cell label={t("有効期限")} value={formatTimestamp(expireAt)} />
      )}
      <Cell
        label={t("獲得日時")}
        value={formatTimestamp(summaryDetail.transaction?.createdAt)}
      />
      <Cell label="ID" value={transactionGroup.id} lastChild={true} />
    </div>
  );
}
